// src/context/LocationContext.tsx
import React, { createContext, useContext, useState, ReactNode } from "react";

// Define types for the location
interface Location {
  lat: number;
  lng: number;
  zoom?: number; // Add optional zoom property
}

interface LocationContextProps {
  selectedLocation: Location;
  setSelectedLocation: React.Dispatch<React.SetStateAction<Location>>;
}

const LocationContext = createContext<LocationContextProps | undefined>(undefined);

// Provider component
interface LocationProviderProps {
  children: ReactNode;
}

export const LocationProvider: React.FC<LocationProviderProps> = ({ children }) => {
  const [selectedLocation, setSelectedLocation] = useState<Location | null>(null);

  return (
    <LocationContext.Provider value={{ selectedLocation, setSelectedLocation }}>
      {children}
    </LocationContext.Provider>
  );
};

// Custom hook to use the location context
export const useLocation = (): LocationContextProps => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error("useLocation must be used within a LocationProvider");
  }
  return context;
};
